import React from 'react'
import { BsFillArrowRightCircleFill } from 'react-icons/bs'
import yellowImage from "../Images/yellow.svg";

const ContactMe = () => {
  return (
     
    <div
    className="row  overflow-hidden  my-5"
    id="Contact_me"
  >
    <div className="col-md-6 main_see4 ">
      <div
        className="contactMainDivv"
        style={{ width: "100%" }}
        data-aos-duration="1000"
        data-aos="zoom-in-up"
      >
        <h1 className="Contact_heading">Connect With Me</h1>
        <div className="d-flex justify-content-between">
          <input
            type="text"
            placeholder="Enter Your First Name"
            className="Contact_input"
          />
          <input
            type="text"
            placeholder="Enter Your Last Name"
            className="Contact_input"
          />
        </div>
        <input
          type="email"
          placeholder="Enter Your Email"
          className="Contact_input2"
        />
        <textarea
          className="w-100 p-3"
          placeholder="Enter Your Message"
        ></textarea>
        <button className="Submitbtn">
          {" "}
          <BsFillArrowRightCircleFill className="icon" /> Submit
        </button>
      </div>
    </div>
    <div className="col-md-6 main_see4 ">
      <img
        src={yellowImage}
        alt=""
        className="svgCotnact"
        data-aos-duration="1000"
        data-aos="zoom-in-left"
      />
    </div>
  </div>
  )
}

export default ContactMe
